import { PageTitle } from "@/components/page-title";
import {
  FinancialAccount,
  PaymentTransactionExpanded,
  PropsWithUser,
} from "@/types";
import { PaymentTransactionAllocationForm } from "./_allocation-form";
import { formatMoney } from "@/utils/format-money";

type Props = {
  payment_transaction: PaymentTransactionExpanded;
  financial_accounts: FinancialAccount[];
};

function PaymentTransactionShow({
  payment_transaction,
  financial_accounts,
}: PropsWithUser<Props>) {
  return (
    <div className="grid grid-cols-[1fr_600px] gap-4">
      <div>
        {payment_transaction.invoices.map((invoice) => (
          <iframe
            key={invoice.id}
            src={invoice.file_url}
            className="h-full w-full"
          />
        ))}
      </div>

      <div>
        <PageTitle>Edit transaction</PageTitle>
        <div>
          <div>Type: {payment_transaction.type}</div>
          <div>Accounting Date: {payment_transaction.accounting_date}</div>
          <div>Date: {payment_transaction.date}</div>
          <div>Counterparty: {payment_transaction.counterparty.name}</div>
          <div>Reason: {payment_transaction.reason}</div>
          <div>Amount: {formatMoney(payment_transaction.amount)}</div>
        </div>
        <div className="mt-10 space-y-6 border-t pt-10">
          <PaymentTransactionAllocationForm
            key={payment_transaction.id}
            payment_transaction={payment_transaction}
            financial_accounts={financial_accounts}
          />
        </div>
      </div>
    </div>
  );
}

export default PaymentTransactionShow;
